import { render, staticRenderFns } from "./DocumentButtons.vue?vue&type=template&id=609cdbf6&scoped=true"
import script from "./DocumentButtons.vue?vue&type=script&lang=js"
export * from "./DocumentButtons.vue?vue&type=script&lang=js"
import style0 from "./DocumentButtons.vue?vue&type=style&index=0&id=609cdbf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609cdbf6",
  null
  
)

export default component.exports